webpackJsonp([92992852587650],{

/***/ 1298:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---spqr-rijtjes-betrekkelijk-voornaamwoord-a0e39f21c11f6a62c5ab.js